import {
  CloseCircleOutlined,
  FilterOutlined,
  PlusCircleOutlined,
} from '@ant-design/icons'
import { Button, Pagination, Space } from 'antd'
import FileDownload from 'js-file-download'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import React, {
  Fragment,
  memo,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import uuid from 'uuid'
import AccessControlAction from '../../components/AccessControlAction'
import {
  CellEclipseBox,
  TableBottomPaginationBlock,
} from '../../components/Common/Table'
import TableComponent from '../../components/Common/TableComponent'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import PageTitle from '../../components/PageTitle'
import { ACL_ACTION_TYPE, DATE_FORMAT_DEFAULT } from '../../constants'
import DashboardLayout from '../../layouts/DashboardLayout'
import AdvanceFilterBlock from './AdvanceFilterBlock'

const DocumentVBPCPage = props => {
  const { loadingAnimationStore, documentStore, history } = props
  const [tableLoading, setTableLoading] = useState(false)

  const { listVBPC, totalCount, filterVBPC } = documentStore

  const downloadFile = useCallback(
    (e, record) => {
      e.stopPropagation()
      loadingAnimationStore.showSpinner(true)
      documentStore
        .getAttachmentVBPC({
          recordId: record.id,
          fileId: record.file_id,
        })
        .then(response => {
          loadingAnimationStore.showSpinner(false)
          FileDownload(
            response.data,
            `${record.document_name}-${record.document_number}.pdf`
          )
        })
        .catch(() => {
          loadingAnimationStore.showSpinner(false)
        })
    },
    [documentStore, loadingAnimationStore]
  )

  const tableColumn = useMemo(
    () => [
      {
        title: 'Tên văn bản',
        align: 'left',
        render: record => record?.document_name,
      },
      {
        title: 'Số quyết định ban hành',
        render: record => (
          <CellEclipseBox>{record?.document_number}</CellEclipseBox>
        ),
      },
      {
        title: 'Ngày ban hành',
        render: record => (
          <CellEclipseBox>
            <time>
              {moment(record?.issue_date).format(DATE_FORMAT_DEFAULT)}
            </time>
          </CellEclipseBox>
        ),
      },
      {
        title: 'Cấp ban hành',
        render: record => (
          <CellEclipseBox>{record?.issue_level || '-'}</CellEclipseBox>
        ),
      },
      {
        title: 'Ban chủ trì xây dựng',
        render: record => (
          <CellEclipseBox>{record?.contruction_board || '-'}</CellEclipseBox>
        ),
      },
      {
        title: 'Trạng thái',
        render: record => (
          <CellEclipseBox>
            {
              ['Đã bãi bỏ', 'Hết hiệu lực', 'Còn hiệu lực'][
                parseInt(record.status) - 1
              ]
            }
          </CellEclipseBox>
        ),
      },
      // {
      //   title: 'Tài liệu đính kèm',
      //   render: record => (
      //     <Button type="primary" onClick={e => downloadFile(e, record)}>
      //       <PaperClipOutlined className={'cursor-pointer'} /> Download
      //     </Button>
      //   ),
      // },
    ],
    [downloadFile]
  )

  const onChangeTable = useCallback(
    (current, size) => {
      if (size !== filterVBPC.size) {
        filterVBPC.page = 1
        filterVBPC.size = size
      } else {
        filterVBPC.page = current
      }
      documentStore.setFilterVBPC(filterVBPC)
    },
    [documentStore, filterVBPC]
  )

  useEffect(() => {
    setTableLoading(true)
    documentStore.getVBPC(filterVBPC).finally(() => setTableLoading(false))
    return () => documentStore.clearDocument()
  }, [documentStore, filterVBPC])

  return (
    <DashboardLayout>
      <Helmet>
        <title>Văn bản pháp chế | Tài liệu</title>
      </Helmet>
      <PageTitle
        location={props.location}
        title={'Văn bản pháp chế'}
        hiddenGoBack>
        <div>
          <Button
            style={{ margin: '0 15px' }}
            type={filterVBPC.isOpen ? 'primary' : 'default'}
            ghost={filterVBPC.isOpen}
            onClick={() => {
              if (filterVBPC.isOpen) {
                documentStore.resetFilter()
              } else {
                documentStore.setFilterVBPC({
                  isOpen: !filterVBPC.isOpen,
                })
              }
            }}>
            {filterVBPC.isOpen ? (
              <Space>
                <CloseCircleOutlined />
                Tắt tìm kiếm nâng cao
              </Space>
            ) : (
              <Space>
                <FilterOutlined />
                Tìm kiếm nâng cao
              </Space>
            )}
          </Button>
          <AccessControlAction aclActionType={ACL_ACTION_TYPE.create__PHAP_CHE}>
            <Button
              onClick={() => history.push('/utility/vbpc/create')}
              style={{ marginBottom: 15 }}
              type={'primary'}>
              <PlusCircleOutlined />
              Tạo Văn bản pháp chế
            </Button>
          </AccessControlAction>
        </div>
      </PageTitle>
      {filterVBPC.isOpen ? (
        <Fragment>
          <AdvanceFilterBlock />
          <div style={{ marginBottom: 16 }} />
        </Fragment>
      ) : null}
      <ContentBlockWrapper>
        <TableComponent
          onRow={record => {
            return {
              onClick: () => history.push(`/utility/vbpc/view/${record.id}`),
            }
          }}
          rowKey={() => uuid()}
          columns={tableColumn}
          dataSource={listVBPC}
          pagination={false}
          onChange={onChangeTable}
          loading={tableLoading}
        />
        <TableBottomPaginationBlock>
          <Pagination
            current={filterVBPC.page}
            pageSize={filterVBPC.size}
            total={totalCount}
            onChange={onChangeTable}
            showSizeChanger={false}
            showLessItems
          />
        </TableBottomPaginationBlock>
      </ContentBlockWrapper>
    </DashboardLayout>
  )
}

DocumentVBPCPage.propTypes = {}

export default memo(
  inject('loadingAnimationStore', 'documentStore')(observer(DocumentVBPCPage))
)
